var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\">{{title}}</h3>\n<button type=\"button\" class=\"close\" ng-click=\"cancel($event)\">&times;</button>\n</div>\n<div class=\"modal-body\">{{body}}</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary pull-left\" ng-click=\"ok()\">\n<span translate=\"COMMON.BTN.YES\"></span>\n</button>\n<button class=\"btn btn-default\" ng-click=\"cancel($event)\">\n<span translate=\"COMMON.BTN.NO\"></span>\n</button>\n</div>\n";
var id1="core/_services/dialog/dialog.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/_services/dialog/dialog.html
// module id = 1050
// module chunks = 0